import styled from 'styled-components';
import { Label } from '@mlc/web-ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const DownloadIcon = styled(FontAwesomeIcon)`
	margin: 0 5px 2px 0;
`;
